import AxiosConfig from 'config/axiosConfig';
import { IHttpStrongTypedResponse } from 'model/IHttpResponse';
import IForex from './IForex';

export const getForex = async () => {
  const response: IHttpStrongTypedResponse<IForex> = await AxiosConfig.get('/forex/today');
  return response;
};